import React, { useState, useEffect } from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faHome, faBox, faBoxesStacked, faGear, faUser, faDoorOpen, faDashboard, 
    faPaperPlane, faMoneyBill, faPeopleGroup, faShoppingBasket, faWarehouse, 
    faExchange, faTruck, faUserAltSlash, faFileInvoice, 
    faMessage,
    faBoxesPacking,
    faComputerMouse,
    faComputer,
    faPieChart,
    faTachographDigital,
    faDigitalTachograph,
    faChartBar,
    faChartArea,
    faChartColumn,
    faDatabase
} from '@fortawesome/free-solid-svg-icons';
import '../css/VerticalNavbar.css';
import { FaAngleRight, FaArrowLeft, FaArrowRight, FaArrowRightArrowLeft, FaCircleArrowRight } from 'react-icons/fa6';
import BackButton from './BackButton';
// Import your logos


const VerticalNavbar = () => {
    const [isCollapsed, setIsCollapsed] = useState(
        () => JSON.parse(localStorage.getItem('isNavbarCollapsed')) || false
    );

    // Retrieve stored user details
    const storedUser = sessionStorage.getItem('user');
    const user = storedUser ? JSON.parse(storedUser) : null;
    const userRole = user?.role || 'guest'; // Default to 'guest' if no role found
   
    const toggleNavbar = () => {
        const newCollapsedState = !isCollapsed;
        setIsCollapsed(newCollapsedState);
        localStorage.setItem('isNavbarCollapsed', JSON.stringify(newCollapsedState));
    };

    useEffect(() => {
        const savedState = JSON.parse(localStorage.getItem('isNavbarCollapsed'));
        if (savedState !== null) {
            setIsCollapsed(savedState);
        }
    }, []);

    return (
        <div className={`vertical-navbar ${isCollapsed ? 'collapsed' : ''}`}>
            
            <Nav defaultActiveKey="/dashboard" className="flex-column">
                {/* Common for all users */}
                <div className="navbar-logo text-center my-3">
                {isCollapsed ? (
                    <img src="Asset.png" alt="Collapsed Logo" className="collapsed-logo" />
                ) : (
                    <img src="Asset.png" alt="Open Logo" className="open-logo" />
                )}
            </div>
                <Nav.Link as={NavLink} to="/dashboard" style={{ marginBottom: '5px' }}>
                    <FontAwesomeIcon icon={faDashboard} className="fa-icon" />
                    {!isCollapsed && <span className="ms-2 cus-size">Dashboard</span>}
                </Nav.Link>

                {/* Admin access only */}
                {(userRole === 'Admin') && (
                    <>
                        <Nav.Link as={NavLink} to="/schemes" style={{ marginBottom: '5px' }}>
                            <FontAwesomeIcon icon={faMoneyBill} className="fa-icon" />
                            {!isCollapsed && <span className="ms-2">Schemes</span>}
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/statistics" style={{ marginBottom: '5px' }}>
                            <FontAwesomeIcon icon={faChartColumn} className="fa-icon" />
                            {!isCollapsed && <span className="ms-2">Statistics</span>}
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/customers" style={{ marginBottom: '5px' }}>
                            <FontAwesomeIcon icon={faPeopleGroup} className="fa-icon" />
                            {!isCollapsed && <span className="ms-2">Customers</span>}
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/inventory" style={{ marginBottom: '5px' }}>
                            <FontAwesomeIcon icon={faWarehouse} className="fa-icon" />
                            {!isCollapsed && <span className="ms-2">Inventory</span>}
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/delivery" style={{ marginBottom: '5px' }}>
                            <FontAwesomeIcon icon={faComputer} className="fa-icon" />
                            {!isCollapsed && <span className="ms-2">Billing & Packing</span>}
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/transaction" style={{ marginBottom: '5px' }}>
                            <FontAwesomeIcon icon={faExchange} className="fa-icon" />
                            {!isCollapsed && <span className="ms-2">Transactions</span>}
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/dataentry" style={{ marginBottom: '5px' }}>
                            <FontAwesomeIcon icon={faDatabase} className="fa-icon" />
                            {!isCollapsed && <span className="ms-2">Data entry</span>}
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/feedback" style={{ marginBottom: '5px' }}>
                            <FontAwesomeIcon icon={faMessage} className="fa-icon" />
                            {!isCollapsed && <span className="ms-2">Messages</span>}
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/blockedusers" style={{ marginBottom: '5px' }}>
                            <FontAwesomeIcon icon={faUserAltSlash} className="fa-icon" />
                            {!isCollapsed && <span className="ms-2">Blocked Users</span>}
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/settings" style={{ marginBottom: '5px' }}>
                            <FontAwesomeIcon icon={faGear} className="fa-icon" />
                            {!isCollapsed && <span className="ms-2">Settings</span>}
                        </Nav.Link>
                    </>
                )}

                {/* Billing access only */}
                {userRole === 'Billing' && (
                    <>
                        <Nav.Link as={NavLink} to="/billing" style={{ marginBottom: '5px' }}>
                            <FontAwesomeIcon icon={faFileInvoice} className="fa-icon" />
                            {!isCollapsed && <span className="ms-2">Billing</span>}
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/inventory" style={{ marginBottom: '5px' }}>
                            <FontAwesomeIcon icon={faWarehouse} className="fa-icon" />
                            {!isCollapsed && <span className="ms-2">Inventory</span>}
                        </Nav.Link>
                    </>
                )}
                {userRole === 'Logistics' && (
                    <>
                        <Nav.Link as={NavLink} to="/packing" style={{ marginBottom: '5px' }}>
                            <FontAwesomeIcon icon={faBoxesPacking} className="fa-icon" />
                            {!isCollapsed && <span className="ms-2">Packing</span>}
                        </Nav.Link>
                    </>
                )}
                {/* Logout (Visible for all users) */}
                <Nav.Link as={NavLink} to="/logout">
                    <FontAwesomeIcon icon={faDoorOpen} className="fa-icon" />
                    {!isCollapsed && <span className="ms-2 cus-link">Logout</span>}
                </Nav.Link>
                {/* <Nav.Link as={NavLink} to="/transactionbugfix" style={{ marginBottom: '5px' }}>
                            <FontAwesomeIcon icon={faGear} className="fa-icon" />
                            {!isCollapsed && <span className="ms-2">transactionbugfix</span>}
                        </Nav.Link> */}
                {/* <Nav.Link as={NavLink} to="/transactionbugfix" style={{ marginBottom: '5px' }}>
                <FontAwesomeIcon icon={faGear} className="fa-icon" />
                {!isCollapsed && <span className="ms-2">Manual transaction fix</span>}
                </Nav.Link> */}
            </Nav>

            <div className="collapse-button">
                <button onClick={toggleNavbar} className="w-100 btn cus-button">
                    {isCollapsed ? <FaArrowRight/> : <FaArrowLeft/>}
                </button>
            </div>
        </div>
    );
};

export default VerticalNavbar;
